module.exports = __webpack_public_path__ + "static/whitepaper_en-8bd3a0480b45c39899787e17049ded26.pdf";